import { ArrowDown, ArrowDownUp, ArrowUp, ChevronsUpDown } from "lucide-react";

/** A column heading one can tap to sort — sits inside the table's own <th>. */
export const SortHeader = ({ label, column, sort, onSort, className = "" }) => {
  const on = sort.key === column;
  return (
    <button
      type="button"
      data-testid={`sort-${column}`}
      onClick={() => onSort(column)}
      title={on ? `${label} — tap to turn it around` : `Sort by ${label}`}
      className={`group inline-flex items-center gap-1 transition-colors duration-200 hover:text-foreground ${
        on ? "text-primary" : ""
      } ${className}`}
    >
      {label}
      {on ? (
        sort.dir === "asc" ? (
          <ArrowUp className="h-3 w-3" />
        ) : (
          <ArrowDown className="h-3 w-3" />
        )
      ) : (
        <ChevronsUpDown className="h-3 w-3 opacity-0 transition-opacity duration-200 group-hover:opacity-50" />
      )}
    </button>
  );
};

/** The same thing for a list that is not a <table> — a row of columns one can sort by. */
export const SortBar = ({ columns, sort, onSort, testId = "sort-bar", note = "" }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid={testId}>
    <span className="label-caps flex items-center gap-1.5 text-muted-foreground">
      <ArrowDownUp className="h-3.5 w-3.5" /> Sort by
    </span>
    {columns.map(([column, label]) => {
      const on = sort.key === column;
      return (
        <button
          key={column}
          type="button"
          data-testid={`${testId}-${column}`}
          onClick={() => onSort(column)}
          className={`font-display inline-flex items-center gap-1 border px-2 py-1 text-[10px] font-bold uppercase tracking-wider transition-colors duration-200 ${
            on
              ? "border-primary text-primary"
              : "border-border text-muted-foreground hover:border-foreground hover:text-foreground"
          }`}
        >
          {label}
          {on &&
            (sort.dir === "asc" ? (
              <ArrowUp className="h-3 w-3" />
            ) : (
              <ArrowDown className="h-3 w-3" />
            ))}
        </button>
      );
    })}
    {note && <span className="text-[11px] text-muted-foreground">{note}</span>}
  </div>
);
